module.exports = __webpack_public_path__ + "img/balkonbruestung.8b8141e8.webp";